import {
  AssetDTO,
  BaseEntityDTO,
  IAssetDTO,
  IBaseEntityDTO,
  IOrderDTO,
  IParticipantDTO,
  ITeamCriteriaDTO,
  IUserDTO,
  OrderDTO,
  ParticipantDTO,
  TeamCriteriaDTO,
  UserDTO,
} from './';

export interface ITeamDTO extends IBaseEntityDTO {
  name: string;
  website: string;
  instagram: string;
  facebook: string;
  twitter: string;
  bio: string;
  vimeo: string;
  youtube: string;
  team_members: IParticipantDTO[];
  teamCriteria: ITeamCriteriaDTO[];
  avatar?: IAssetDTO;
  test: boolean;
  teamLeader?: IUserDTO;
  orders: IOrderDTO[];
}

export class TeamDTO extends BaseEntityDTO implements ITeamDTO {
  name: string;
  website: string;
  instagram: string;
  facebook: string;
  twitter: string;
  bio: string;
  vimeo: string;
  youtube: string;
  team_members: IParticipantDTO[];
  teamCriteria: ITeamCriteriaDTO[];
  avatar?: IAssetDTO;
  test: boolean;
  teamLeader?: IUserDTO | undefined;
  orders: IOrderDTO[];

  constructor(data?: Partial<TeamDTO>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
    this.name = data?.name ?? '';
    this.website = data?.website ?? '';
    this.instagram = data?.instagram ?? '';
    this.facebook = data?.facebook ?? '';
    this.twitter = data?.twitter ?? '';
    this.bio = data?.bio ?? '';
    this.vimeo = data?.vimeo ?? '';
    this.youtube = data?.youtube ?? '';
    this.test = data?.test ?? false;
    this.team_members = data?.team_members
      ? data.team_members.map((teamMember) => new ParticipantDTO(teamMember))
      : [];
    this.teamCriteria = data?.teamCriteria
      ? data.teamCriteria.map((crit) => new TeamCriteriaDTO(crit))
      : [];
    this.avatar = data?.avatar ? new AssetDTO(data.avatar) : undefined;
    this.teamLeader = data?.teamLeader ? new UserDTO(data.teamLeader) : undefined;
    this.orders = data?.orders ? data.orders.map((order) => new OrderDTO(order)) : [];
  }
}
